const float64ArrayPrototype = Object.getPrototypeOf(new Float64Array());

export function isFloat64Array(value: unknown): value is Float64Array {
  return !!value && Object.getPrototypeOf(value) === float64ArrayPrototype;
}
